"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.injectRowOffset = exports.default = exports.HEADER_ROW_HEIGHT = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var _reverse = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reverse"));
var _sort = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/sort"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));
var _map2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/map"));
var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));
var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));
var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/values"));
var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array"));
var _react = _interopRequireDefault(require("react"));
var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));
var T = _interopRequireWildcard(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _jsWorkerSearch = _interopRequireDefault(require("js-worker-search"));
var _reactHighlightWords = _interopRequireDefault(require("react-highlight-words"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _immutable = _interopRequireDefault(require("immutable"));
var _reactWindowInfiniteLoader = _interopRequireDefault(require("react-window-infinite-loader"));
var _reactVirtualizedAutoSizer = _interopRequireDefault(require("react-virtualized-auto-sizer"));
var _reactWindow = require("react-window");
var _reactIntl = require("react-intl");
var _reselect = require("reselect");
var _constants = require("../../constants");
var _general = require("../../selectors/general");
var _AuComponent = _interopRequireDefault(require("./AuComponent"));
var _SortIndicator = _interopRequireDefault(require("./SortIndicator"));
var _Row = _interopRequireDefault(require("./Row"));
var _TableCell = _interopRequireDefault(require("./TableCell"));
var _context2, _context3, _context4, _context5, _context6, _context10, _context11, _context17, _context18, _context20, _context21, _context22, _context23;
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var styles = {
  "container": "responsive_table-module__container___SN_XF",
  "table": "responsive_table-module__table___atfaD",
  "table_body": "responsive_table-module__table_body___epJTn",
  "header_row": "responsive_table-module__header_row___WJh9S",
  "column": "responsive_table-module__column___SsD03",
  "title": "responsive_table-module__title___CmJN4",
  "toggle": "responsive_table-module__toggle___jJbuI",
  "expand": "responsive_table-module__expand___F1a4u responsive_table-module__toggle___jJbuI",
  "collapse": "responsive_table-module__collapse___QA5YP responsive_table-module__toggle___jJbuI",
  "sortable_column": "responsive_table-module__sortable_column___dKHmz responsive_table-module__column___SsD03",
  "units": "responsive_table-module__units____IfvR",
  "row": "responsive_table-module__row___LPvGL",
  "expanded": "responsive_table-module__expanded___bFWek responsive_table-module__row___LPvGL",
  "content": "responsive_table-module__content___SdAZQ",
  "even": "responsive_table-module__even___cO05B responsive_table-module__row___LPvGL",
  "odd": "responsive_table-module__odd___SMifW responsive_table-module__row___LPvGL",
  "toggle_column": "responsive_table-module__toggle_column___dpfUC responsive_table-module__column___SsD03",
  "left": "responsive_table-module__left___Pc1Dk",
  "right": "responsive_table-module__right___j3EPk",
  "center": "responsive_table-module__center___yZ32J",
  "hidden": "responsive_table-module__hidden___sXudr",
  "switch_column": "responsive_table-module__switch_column___HtWac responsive_table-module__column___SsD03",
  "actions_column": "responsive_table-module__actions_column___sueyQ responsive_table-module__column___SsD03",
  "expansion": "responsive_table-module__expansion___KF9gd",
  "collapsed_columns": "responsive_table-module__collapsed_columns___L7q8h",
  "column_cell": "responsive_table-module__column_cell___uBfQk",
  "label": "responsive_table-module__label___wIbL7",
  "colon": "responsive_table-module__colon___Rre1_",
  "msg": "responsive_table-module__msg___BrIG2",
  "msgicon": "responsive_table-module__msgicon___R9APo",
  "no_rows": "responsive_table-module__no_rows___iaYdK responsive_table-module__msg___BrIG2",
  "fetching": "responsive_table-module__fetching___b5n61 responsive_table-module__msg___BrIG2",
  "ellipsis": "responsive_table-module__ellipsis___NKeuz",
  "highlight": "responsive_table-module__highlight___ilhHD",
  "tooltip": "responsive_table-module__tooltip___jhh1B",
  "copy": "responsive_table-module__copy___DshAD"
};
const TOGGLE_COLUMN_WIDTH = 44;
const HEADER_ROW_HEIGHT = 48;
exports.HEADER_ROW_HEIGHT = HEADER_ROW_HEIGHT;
const getProcessedCollection = (0, _general.createDeepEqualSelector)([args => args.collection, args => args.columnDefs, args => args.processors], (collection, columnDefs, customProcesors = {}) => {
  collection = (0, _map.default)(collection).call(collection, resource => {
    var _context;
    (0, _forEach.default)(_context = (0, _filter.default)(columnDefs).call(columnDefs, col => col.processors)).call(_context, col => {
      const ref = col.ref || {};
      const prop = ref.textProperty || ref.idProperty || col.property;
      const path = prop.split('.');
      let processedValue = resource.getIn(path, '');
      for (let {
        func,
        args
      } of col.processors) {
        if (typeof processedValue !== 'undefined' && typeof processedValue[func] === 'function') {
          processedValue = processedValue[func](...args);
        } else if (typeof customProcesors[func] === 'function') {
          processedValue = customProcesors[func]({
            ...args,
            value: processedValue,
            rowData: resource
          });
        }
      }
      resource = resource.setIn(path, processedValue);
    });
    return resource;
  });
  return collection;
});
const getFilteredList = (0, _reselect.createSelector)([args => args.collection, args => args.pkField, args => args.filteredIds], (collection, pkField, filteredIds) => {
  if (filteredIds) {
    return (0, _filter.default)(collection).call(collection, item => (0, _includes.default)(filteredIds).call(filteredIds, item.get(pkField))).toList();
  }
  return collection.toList();
});
const getSortedList = (0, _reselect.createSelector)([args => args.collection, args => args.sortBy, args => args.sortDirection, args => args.sortDisabled], (collection, sortBy, sortDirection, sortDisabled) => {
  if (sortBy && sortDirection && !sortDisabled) {
    return collection.sortBy(item => item.get(sortBy, ''), (a, b) => {
      // equal items sort equally
      if (a === b) {
        return 0;
      } else if (a === null || a === '') {
        // nulls/empty sort after anything else
        return 1;
      } else if (b === null || b === '') {
        return -1;
      }

      // default sort
      return a < b ? -1 : 1;
    }).update(collection => sortDirection === "DESC" ? (0, _reverse.default)(collection).call(collection) : collection).toList();
  }
  return collection.toList();
});
const injectRowOffset = TargetComponent => {
  return class extends _react.default.Component {
    state = {};
    handleMouseOver = () => {
      const rowEl = this.el.closest(`.${styles.row}`);
      const containerEl = rowEl.closest('.ReactVirtualized__Grid');
      this.setState({
        topOffset: rowEl.offsetTop,
        bottomOffset: containerEl.scrollHeight - rowEl.offsetTop - rowEl.offsetHeight
      });
    };
    render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        ref: el => this.el = el,
        onMouseOver: this.handleMouseOver
      }, /*#__PURE__*/_react.default.createElement(TargetComponent, (0, _extends2.default)({}, this.props, this.state)));
    }
  };
};
exports.injectRowOffset = injectRowOffset;
class ResponsiveTable extends _AuComponent.default {
  static contextTypes = {
    units: T.object
  };
  static propTypes = {
    fetching: T.bool,
    formatters: T.object,
    processors: T.object,
    timezone: T.string,
    tableDef: T.object.isRequired,
    tableData: T.oneOfType([_reactImmutableProptypes.default.list, (0, _map.default)(_reactImmutableProptypes.default)]).isRequired,
    searchText: T.string,
    searchEnabled: T.bool,
    hasNextPage: T.bool,
    loadNextPage: T.func,
    onSearch: T.func,
    failureToFetchError: T.func
  };
  static defaultProps = {
    fetching: false,
    timezone: _momentTimezone.default.tz.guess(),
    searchText: '',
    searchEnabled: false,
    hasNextPage: false,
    loadNextPage: _constants.NOOP,
    onSearch: _constants.NOOP
  };

  /**
   * The most recent row heights
   * @type {Array}
   */
  rowHeights = [];

  /**
   * The most recent sum of columns widths
   * @type {Number}
   */
  mostRecentWidth = 0;

  /**
   * An array containing collapsed columns definitions
   * @type {Array}
   */
  collapsedColumnDefs = [];

  /**
   * Cache for storing calculated rows heights
   * @type {CellMeasurerCache}
   */
  /* cache = new CellMeasurerCache({ fixedWidth: true, minHeight: 48 }); */

  /**
   * Last next page promise or null if none has been called.
   * Used to control row loading.
   * @type {Promise|null}
   */
  nextPagePromise = null;

  /**
   * True if nextPagePromise is unresolved, false otherwise.
   * @type {Boolean}
   */
  _fetching = false;
  infiniteLoaderRef = /*#__PURE__*/_react.default.createRef();
  tooltipRef = /*#__PURE__*/_react.default.createRef();
  get fetching() {
    // This helps guarantee that the fetching window is definitely true while
    // more rows are loading despite the props passed
    return this._fetching || this.props.fetching || this.searching;
  }
  set fetching(val) {
    this._fetching = val;
  }
  get searching() {
    // true if either local or server-side search is happening
    return this.state.searching;
  }
  constructor(props) {
    super(props);
    const {
      tableDef,
      tableData,
      processors,
      hasNextPage
    } = props;
    const sortBy = ((0, _sort.default)(tableDef) || {}).columnId;
    const sortDirection = ((0, _sort.default)(tableDef) || {}).direction === 'up' ? "ASC" : "DESC";
    const collection = getProcessedCollection({
      collection: tableData,
      columnDefs: tableDef.columnDefs,
      processors
    });
    // NOTE `searching`is used only for the initial data render and it won't
    // change its state after the first `performSearch` is completed.
    const searching = Boolean(props.searchText);
    this.state = {
      expandedRows: {},
      filteredIds: undefined,
      sortedList: getSortedList({
        collection,
        sortBy,
        sortDirection,
        sortDisabled: hasNextPage
      }),
      searching,
      sortBy,
      sortDirection
    };
    if (props.searchEnabled || searching) {
      this.buildSearchIndex();
    }
  }
  componentDidMount() {
    const {
      searchText
    } = this.props;
    if (searchText !== '') {
      this.performSearch(searchText).finally(() => this.setState({
        searching: false
      }));
    }
  }
  componentDidUpdate(prevProps, prevState) {
    const {
      tableDef,
      tableData,
      processors,
      searchText,
      searchEnabled,
      hasNextPage
    } = this.props;
    const {
      expandedRows,
      sortBy,
      sortDirection
    } = this.state;
    const dataHasChanged = tableData !== prevProps.tableData;
    let doSearch = false;
    let newState = {};

    // 1. if `dataHasChanged` -- obvious -- update the index and do search
    // 2. if `searchEnabled` went from `disabled` to `enabled` we should also
    // update the index and do search, but only if we were not in the middle of
    // a search already (`searching` === true)
    if (dataHasChanged || !prevProps.searchEnabled && !prevState.searching) {
      if (searchEnabled) {
        this.buildSearchIndex();
        doSearch = true;
      }
      if (dataHasChanged) {
        const collection = getProcessedCollection({
          collection: tableData,
          columnDefs: tableDef.columnDefs,
          processors
        });
        newState.sortedList = getSortedList({
          collection,
          sortBy,
          sortDirection,
          sortDisabled: hasNextPage
        });
        newState.filteredIds = null;
      }
    } else if (searchEnabled && searchText !== prevProps.searchText) {
      doSearch = true;
    }
    if (doSearch) {
      if (searchText !== '') {
        this.performSearch(searchText);
      } else {
        newState.filteredIds = null;
      }
    }
    if ((0, _keys.default)(newState).length) {
      this.setState(newState);
    }

    // if there were any expanded rows - trigger re-render manually,
    // since the order may have changed and the table won't detect it.
    if (doSearch || (0, _keys.default)(expandedRows).length || (0, _keys.default)(prevState.expandedRows).length) {
      (0, _setTimeout2.default)(() => this.forceUpdateRows());
    }
  }
  loadMoreRows = (0, _bind.default)(_context2 = this.loadMoreRows).call(_context2, this);
  loadMoreRows() {
    const {
      loadNextPage
    } = this.props;
    if (this.fetching) {
      if (!this.nextPagePromise) {
        // this should never happen, but just in case
        return _promise.default.resolve();
      }
      this.nextPagePromise = this.nextPagePromise.then(loadNextPage).then(() => this.fetching = false);
      return this.nextPagePromise;
    }
    this.fetching = true;
    this.nextPagePromise = loadNextPage().then(() => this.fetching = false);
    return this.nextPagePromise;
  }
  isRowLoaded = (0, _bind.default)(_context3 = this.isRowLoaded).call(_context3, this);
  isRowLoaded({
    index
  }) {
    const {
      tableDef,
      hasNextPage
    } = this.props;
    const {
      sortedList,
      filteredIds
    } = this.state;
    const filteredList = getFilteredList({
      collection: sortedList,
      pkField: tableDef.tablePkField,
      filteredIds
    });
    return !hasNextPage || index < filteredList.size;
  }
  getRowHeight = (0, _bind.default)(_context4 = this.getRowHeight).call(_context4, this);
  getRowHeight(index) {
    return this.rowHeights[index] || HEADER_ROW_HEIGHT;
  }
  setRowHeight = (0, _bind.default)(_context5 = this.setRowHeight).call(_context5, this);
  setRowHeight(index, size) {
    this.rowHeights[index] = size;
  }
  buildSearchIndex = (0, _bind.default)(_context6 = this.buildSearchIndex).call(_context6, this);
  buildSearchIndex() {
    const {
      tableDef,
      tableData,
      processors
    } = this.props;

    // https://github.com/bvaughn/js-worker-search#custom-tokenizer-patterns
    // do not treat space, "-" and "/" as a delimiters
    this._search = new _jsWorkerSearch.default({
      tokenizePattern: /[^a-z0-9-\s/]+/
    });
    const notIndexed = new _map2.default();
    const columnDefs = tableDef.columnDefs;
    const collection = getProcessedCollection({
      collection: tableData,
      columnDefs,
      processors
    });
    (0, _forEach.default)(collection).call(collection, resource => {
      var _context7;
      (0, _forEach.default)(_context7 = (0, _filter.default)(columnDefs).call(columnDefs, col => col.searchable)).call(_context7, col => {
        let ref = col.ref || {};
        let prop = ref.textProperty || ref.idProperty || col.property;
        let value = resource.getIn(prop.split('.'), '');
        if (typeof value !== 'object') {
          this._search.indexDocument(resource.get(tableDef.tablePkField), value);
        } else {
          const prevValue = notIndexed.get(col.property);
          notIndexed.set(col.property, (prevValue || 0) + 1);
        }
      });
    });
    if (notIndexed.size) {
      for (let [key, num] of notIndexed) {
        /* eslint-disable no-console */
        console.warn(`Unable to index ${num} document(s) by column "${key}" \
          due to unsupported document type.`);
        /* eslint-enable no-console */
      }
    }
  }

  forceUpdateRows() {
    /* this.cache.clearAll(); */

    if (this.listRef) {
      this.listRef.recomputeRowHeights();
    }
  }
  performSearch(text) {
    const searching = this._search.search(text).then(filteredIds => {
      const expandedRows = {};
      for (let i = 0, len = filteredIds.length; i < len; i++) {
        const id = filteredIds[i];
        // keep only those expanded rows that match filtered ids
        if (id in this.state.expandedRows) {
          expandedRows[id] = this.state.expandedRows[id];
        }
      }
      this.setState({
        expandedRows,
        filteredIds
      });
    }).catch(error => {
      console.warn(error); /* eslint-disable-line no-console */
      throw error;
    });
    this.props.onSearch(searching);
    return searching;
  }

  /**
   * Determines the flex-shrink, flex-grow, and width values for a cell.
   */
  _getFlexStyleForColumn(column, customStyle = {}) {
    const flexValue = `${column.props.flexGrow} ${column.props.flexShrink} ${column.props.width}px`;
    const style = {
      ...customStyle,
      flex: flexValue,
      msFlex: flexValue,
      WebkitFlex: flexValue
    };
    if (column.props.maxWidth) {
      style.maxWidth = column.props.maxWidth;
    }
    if (column.props.minWidth) {
      style.minWidth = column.props.minWidth;
    }
    return style;
  }
  _getHeaderColumns() {
    var _context8, _context9;
    // store table columns
    this._columns = this.getColumns();
    // Precompute and cache column styles before rendering rows and columns to speed things up
    this.cachedColumnStyles = [];
    (0, _forEach.default)(_context8 = this._columns).call(_context8, (column, index) => {
      this.cachedColumnStyles[index] = this._getFlexStyleForColumn(column, column.props.style);
    });
    return (0, _map.default)(_context9 = this._columns).call(_context9, (column, index) => this._createHeader({
      column,
      index
    }));
  }
  _createHeader({
    column,
    index
  }) {
    const {
      sortBy,
      sortDirection
    } = this.state;
    const {
      hasNextPage
    } = this.props;
    const {
      dataKey,
      disableSort,
      headerRenderer,
      label,
      columnData,
      isActionsColumn
    } = column.props;
    const sortEnabled = !disableSort && !hasNextPage;
    const style = this._getFlexStyleForColumn(column, column.props.style);
    const renderedHeader = headerRenderer({
      columnData,
      dataKey,
      disableSort,
      label,
      sortBy,
      sortDirection
    });
    const columnProps = {
      role: 'columnheader'
    };
    if (sortEnabled) {
      // If this is a sortable header, clicking it should update the table data's sorting.
      const newSortDirection = sortBy !== dataKey || sortDirection === "DESC" ? "ASC" : "DESC";
      columnProps["aria-label"] = column.props["aria-label"] || label || dataKey;
      columnProps.tabIndex = 0;
      columnProps.onClick = () => this.handleHeaderClick(dataKey, newSortDirection);
    }
    if (sortBy === dataKey) {
      columnProps["aria-sort"] = sortDirection === "ASC" ? "ascending" : "descending";
    }
    const classNames = (0, _classnames.default)({
      [styles.actions_column]: isActionsColumn,
      [styles.sortable_column]: sortEnabled,
      [styles.column]: !isActionsColumn && !sortEnabled,
      [styles[column.props.align]]: column.props.align
    }, column.props.headerClassName);
    return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, columnProps, {
      key: `Header-Col${index}`,
      className: classNames,
      style: style
    }), renderedHeader);
  }
  headerRowRenderer({
    className,
    columns,
    style
  }) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: className,
      role: "row",
      style: style
    }, columns);
  }
  headerRenderer = (0, _bind.default)(_context10 = this.headerRenderer).call(_context10, this);
  headerRenderer({
    columnDef,
    dataKey,
    label,
    sortBy,
    sortDirection
  }) {
    const {
      hasNextPage
    } = this.props;
    const showSortIndicator = sortBy === dataKey && !hasNextPage;
    const {
      unitType,
      unitLabel
    } = columnDef;
    const children = [/*#__PURE__*/_react.default.createElement("span", {
      key: "label",
      className: styles.title,
      title: label
    }, label)];
    if (unitType && unitLabel) {
      children.push( /*#__PURE__*/_react.default.createElement("span", {
        className: styles.units,
        key: "unittype"
      }, "(", this.context.units[unitType][unitLabel], ")"));
    }
    if (showSortIndicator) {
      children.push( /*#__PURE__*/_react.default.createElement(_SortIndicator.default, {
        key: "SortIndicator",
        sortDirection: sortDirection
      }));
    }
    return children;
  }
  getColumns = (0, _bind.default)(_context11 = this.getColumns).call(_context11, this);
  getColumns() {
    var _context12;
    const {
      tableDef,
      expansion
    } = this.props;
    const {
      expandedRows
    } = this.state;
    let columnDefs = (0, _filter.default)(_context12 = tableDef.columnDefs).call(_context12, col => col.display);
    let columnsWidth = (0, _reduce.default)(columnDefs).call(columnDefs, (acc, col) => acc + col.width || 0, 0);

    // columns to be rendered
    const columns = [];
    // map of columns that doesn't fit: {<property>:<List definition>}
    const collapsed = {};
    let showToggle = Boolean(expansion);
    if (this.mostRecentWidth && columnsWidth > this.mostRecentWidth) {
      var _context13, _context14;
      // list of columns that can be collapsed (has "weight"), sorted by "weight" ASC
      let collapsible = (0, _sort.default)(_context13 = (0, _map.default)(_context14 = (0, _filter.default)(columnDefs).call(columnDefs, col => typeof col.weight !== 'undefined')).call(_context14, def => ({
        property: def.property,
        def
      }))).call(_context13, (a, b) => a.def.weight - b.def.weight);
      columnsWidth += TOGGLE_COLUMN_WIDTH;
      showToggle = showToggle || Boolean(collapsible.length);

      // subtract collapsible columns widths until it fits
      for (let col of collapsible) {
        collapsed[col.property] = col.def;
        columnsWidth -= col.def.width;
        if (columnsWidth <= this.mostRecentWidth) {
          break;
        }
      }
    }
    columns.push( /*#__PURE__*/_react.default.createElement("div", {
      key: 'toggle',
      dataKey: '',
      width: TOGGLE_COLUMN_WIDTH,
      flexShrink: 0,
      disableSort: true,
      className: (0, _classnames.default)(styles.toggle_column, {
        [styles.hidden]: !showToggle
      }),
      headerClassName: (0, _classnames.default)(styles.toggle_column, {
        [styles.hidden]: !showToggle
      }),
      headerRenderer: () => {
        const className = (0, _keys.default)(expandedRows).length ? styles.collapse : styles.expand;
        return /*#__PURE__*/_react.default.createElement("div", {
          className: className,
          onClick: () => this.handleToggleClick({})
        });
      },
      cellRenderer: ({
        rowIndex,
        ...props
      }) => {
        const rowData = this.getDatum(rowIndex);
        const className = rowData.get(tableDef.tablePkField) in expandedRows ? styles.collapse : styles.expand;
        return /*#__PURE__*/_react.default.createElement(_TableCell.default, (0, _extends2.default)({}, props, {
          key: props.dataKey
        }), /*#__PURE__*/_react.default.createElement("div", {
          className: className,
          onClick: () => this.handleToggleClick({
            index: rowIndex,
            rowData
          })
        }));
      }
    }));
    for (let col of columnDefs) {
      if (collapsed[col.property]) {
        // do not render collapsed column
        continue;
      }
      let isActionsColumn = false;
      let className = styles.column;
      if (col.formatters) {
        var _context15;
        let formatter = (0, _find.default)(_context15 = col.formatters).call(_context15, f => {
          var _context16;
          return (0, _includes.default)(_context16 = ['actionCell', 'switchCell']).call(_context16, f.func);
        });
        if (formatter && formatter.func === 'actionCell') {
          isActionsColumn = true;
          className = styles.actions_column;
        } else if (formatter && formatter.func === 'switchCell') {
          isActionsColumn = true;
          className = styles.switch_column;
        }
      }
      columns.push( /*#__PURE__*/_react.default.createElement("div", {
        key: col.property,
        label: this.props.intl.formatMessage({
          id: col.labelId
        }, col.labelValues),
        width: col.width || 100,
        className: (0, _classnames.default)(className, {
          [styles[col.align]]: col.align
        }),
        align: col.align,
        flexGrow: 'flexGrow' in col ? col.flexGrow : 0,
        flexShrink: 'flexShrink' in col ? col.flexShrink : 1,
        dataKey: col.property,
        disableSort: col.sortable === false,
        headerRenderer: props => this.headerRenderer({
          columnDef: col,
          ...props
        }),
        cellRenderer: this.getCellRendererFn(col),
        isActionsColumn: isActionsColumn
      }));
    }

    // store collapsed columns so we could reuse them in rowRenderer
    // NOTE: state can't be used since calculation is occurring during render
    this.collapsedColumnDefs = (0, _values.default)(collapsed);
    return columns;
  }
  getCellRendererFn = (0, _bind.default)(_context17 = this.getCellRendererFn).call(_context17, this);
  getCellRendererFn(columnDef) {
    const {
      formatters: customFormatters
    } = this.props;
    return ({
      cellData,
      rowData,
      dataKey,
      ...otherProps
    }) => {
      const {
        searchText
      } = this.props;
      const ref = columnDef.ref || {};
      const prop = ref.textProperty || ref.idProperty;
      let value = prop ? rowData.getIn(prop.split('.'), '') : cellData;
      if (columnDef.searchable && searchText) {
        value = /*#__PURE__*/_react.default.createElement(_reactHighlightWords.default, {
          highlightClassName: styles.highlight,
          searchWords: searchText.split(/\s+/),
          autoEscape: true,
          textToHighlight: value
        });
      }
      if (columnDef.formatters) {
        for (let {
          func,
          args
        } of columnDef.formatters) {
          let argsCopy = {
            ...args
          };
          // Use passed timezone, if there is no timezone specified in tableDef settings
          if (func === 'date' && !argsCopy.timezone) {
            argsCopy.timezone = this.props.timezone;
          }
          if (typeof value !== 'undefined' && typeof value[func] === 'function') {
            value = (0, _isArray.default)(args) ? value[func](...args) : value[func](argsCopy);
          } else if (typeof customFormatters[func] === 'function') {
            if ((0, _isArray.default)(args)) {
              value = customFormatters[func]({
                args: argsCopy,
                value,
                rowData,
                columnDef
              });
            } else {
              value = customFormatters[func]({
                ...argsCopy,
                value,
                rowData,
                columnDef
              });
            }
          }
        }
      }
      return /*#__PURE__*/_react.default.createElement(_TableCell.default, (0, _extends2.default)({}, otherProps, {
        key: dataKey
      }), value);
    };
  }
  handleToggleClick = (0, _bind.default)(_context18 = this.handleToggleClick).call(_context18, this);
  handleToggleClick({
    index,
    rowData
  }) {
    const {
      tableDef
    } = this.props;
    if (rowData) {
      // toggle single row
      const id = rowData.get(tableDef.tablePkField);
      this.setState(prevState => {
        let expandedRows = {
          ...prevState.expandedRows
        };
        let isExpanded = (id in expandedRows);
        if (isExpanded) {
          delete expandedRows[id];
        } else {
          expandedRows[id] = index;
        }
        return {
          expandedRows
        };
      });
    } else {
      var _context19;
      // toggle all
      const expandedCount = (0, _keys.default)(this.state.expandedRows).length;
      // if there are expanded rows - colapse all, otherwise - expand all
      const expandedRows = expandedCount ? {} : (0, _reduce.default)(_context19 = this.state.sortedList).call(_context19, (hash, rowData) => {
        hash[rowData.get(tableDef.tablePkField)] = true;
        return hash;
      }, {});
      this.setState({
        expandedRows
      });
    }
  }
  handleHeaderClick = (0, _bind.default)(_context20 = this.handleHeaderClick).call(_context20, this);
  handleHeaderClick(sortBy, sortDirection) {
    const {
      tableDef,
      tableData,
      processors,
      hasNextPage
    } = this.props;
    const collection = getProcessedCollection({
      collection: tableData,
      columnDefs: tableDef.columnDefs,
      processors
    });
    const sortedList = getSortedList({
      collection,
      sortBy,
      sortDirection,
      sortDisabled: hasNextPage
    });
    this.setState({
      sortedList,
      sortBy,
      sortDirection
    });
  }
  rowRenderer = /*#__PURE__*/_react.default.memo((0, _bind.default)(_context21 = this.rowRenderer).call(_context21, this), _reactWindow.areEqual);
  rowRenderer({
    index,
    style
  }) {
    return /*#__PURE__*/_react.default.createElement(_Row.default, {
      style: style,
      index: index,
      styles: styles,
      rowData: this.getDatum(index),
      isExpanded: this.getDatum(index)?.get(this.props.tableDef.tablePkField) in this.state.expandedRows && this.collapsedColumnDefs.length,
      isRowLoaded: this.isRowLoaded({
        index
      }),
      collapsedColumnDefs: this.collapsedColumnDefs,
      setRowHeight: this.setRowHeight,
      columns: this.getColumns(),
      cachedColumnStyles: this.cachedColumnStyles,
      tooltipRef: this.tooltipRef,
      getCellRendererFn: this.getCellRendererFn,
      expansion: this.props.expansion,
      intl: this.props.intl
    });
  }
  getDatum(index) {
    const {
      tableDef
    } = this.props;
    const {
      sortedList,
      filteredIds
    } = this.state;
    const filteredList = getFilteredList({
      collection: sortedList,
      pkField: tableDef.tablePkField,
      filteredIds
    });
    return filteredList.get(index);
  }
  noRowsRenderer(fetching) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)({
        [styles.no_rows]: !this.fetching,
        [styles.fetching]: this.fetching
      })
    }, this.props.intl.formatMessage({
      id: `au.table.data${fetching ? 'Fetching' : 'Empty'}Message`
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: styles.msgicon
    }));
  }
  emptyNoRowsRenderer = (0, _bind.default)(_context22 = this.noRowsRenderer).call(_context22, this, false);
  fetchingNoRowsRenders = (0, _bind.default)(_context23 = this.noRowsRenderer).call(_context23, this, true);
  handleRef(ref, registerChild) {
    this.listRef = ref;
    return registerChild(ref);
  }
  render() {
    const {
      tableDef,
      timezone,
      searchText,
      failureToFetchError
    } = this.props;
    const {
      sortedList,
      sortBy,
      sortDirection,
      filteredIds
    } = this.state;

    // we don't want to render the data before initial search is completed
    const filteredList = this.searching ? _immutable.default.List() : getFilteredList({
      collection: sortedList,
      pkField: tableDef.tablePkField,
      filteredIds
    });

    // const noRowsRenderer = this.fetching ? this.fetchingNoRowsRenders : this.emptyNoRowsRenderer;

    return /*#__PURE__*/_react.default.createElement("div", {
      className: styles.container
    }, /*#__PURE__*/_react.default.createElement(_reactWindowInfiniteLoader.default, {
      isItemLoaded: this.isRowLoaded,
      loadMoreItems: this.loadMoreRows,
      itemCount: Infinity
    }, ({
      onItemsRendered,
      ref
    }) => /*#__PURE__*/_react.default.createElement(_reactVirtualizedAutoSizer.default, {
      styles: styles.container
    }, ({
      width,
      height
    }) => {
      this.mostRecentWidth = width;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: styles.table
      }, this.headerRowRenderer({
        className: styles.header_row,
        columns: this._getHeaderColumns(),
        style: {
          height: HEADER_ROW_HEIGHT,
          overflow: "hidden",
          width: width
        }
      }), /*#__PURE__*/_react.default.createElement(_reactWindow.VariableSizeList, {
        ref: ref,
        className: styles.table_body,
        width: width,
        height: height - HEADER_ROW_HEIGHT,
        itemCount: filteredList.size,
        itemSize: this.getRowHeight,
        sortBy: sortBy,
        sortDirection: sortDirection,
        onItemsRendered: onItemsRendered,
        searchText: searchText,
        timezone: timezone
      }, this.rowRenderer));
    })), /*#__PURE__*/_react.default.createElement("div", {
      ref: this.tooltipRef
    }));
  }
}
var _default = (0, _reactIntl.injectIntl)(ResponsiveTable, {
  forwardRef: true
});
exports.default = _default;